export default {
  "@sparky/framework": "~0.0.40",
  "@sparky/webpack-cra": "0.6.8",
  "react": "16.14.0",
  "react-dom": "16.14.0",
  "react-is": "16.13.1",
  "react-intl": "5.25.1",
  "history": "4.10.1",
  "lodash": "4.17.21",
  "lodash-es": "4.17.21",
  "redux": "4.2.0",
  "react-redux": "7.2.8",
  "prop-types": "15.8.1",
  "date-fns": "2.29.3",
  "moment": "2.29.4",
  "classnames": "2.3.1",
  "i18next": "20.6.1",
  "i18next-icu": "2.0.3",
  "react-hook-form": "7.44.3",
  "reactstrap": "8.10.1",
  "react-table": "7.8.0",
  "core-js": "3.36.0",
  "regenerator-runtime": "0.14.1",
  "react-router": "5.3.4",
  "react-router-dom": "5.3.4",
  "oidc-client": "1.11.5",
  "axios": "0.28.1",
  "eventemitter3": "4.0.7",
  "rc-tree": "5.6.7",
  "react-focus-on": "3.8.1",
  "@sparky/cli": "0.2.7",
  "@sparky/webpack-config": "0.3.57",
  "intl-messageformat": "9.13.0",
  "urn-lib": "2.0.0",
  "@material-ui/core": "4.11.4",
  "@panwds/icons": "6.5.2",
  "@panwds/react-filters[v8-latest]": "6.11.2",
  "@panwds/react-form[v8-latest]": "5.3.16",
  "@sparky/panwds-react-nav": "0.17.15-beta.0",
  "@panwds/react-table[v8-latest]": "6.4.3",
  "@panwds/react-ui[v8-latest]": "8.18.2",
  "@sparky/react-nav": "0.18.0-beta.5",
  "@panwds/tailwindcss[v8-latest]": "11.0.1",
  "@panwds/typography": "0.9.13",
  "@sparky/panwds-legacy": "1.6.104",
  "@panwds/react-filters[legacy]": "1.6.1",
  "@panwds/react-form[legacy]": "1.2.2",
  "@panwds/react-table[legacy]": "1.2.1",
  "@panwds/react-ui[legacy]": "1.6.0",
  "@panwds/tailwindcss[legacy]": "6.2.0",
  "@sparky/panwds-tw-scoped-css": "11.0.1-10130-1030-1020-843-620-alpha",
  "@sparky/panwds-v8": "8.11.1-beta-661-531-6127",
  "@panwds/react-filters[v8]": "6.6.1",
  "@panwds/react-form[v8]": "5.3.1",
  "@panwds/react-table[v8]": "6.1.27",
  "@panwds/react-ui[v8]": "8.11.1",
  "@sparky/token-manager": "22.0.2"
};
